import React, {FC, useEffect} from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import {Suggestion} from "../../models/dadata/party";
import {AuthService} from "../../service/AuthService";


interface companyAutocompleteInterface{
    setInn:Function
}

const CompanyAutocomplete:FC<companyAutocompleteInterface> = ({setInn}) => {
    const [value, setValue] = React.useState<Suggestion | null>(null);
    const [inputValue, setInputValue] = React.useState('');
    const [options, setOptions] = React.useState<Suggestion[]>([]);
    const loaded = React.useRef(false);

    useEffect(()=>{
        async function getCompany(){
            try{
                let newOptions = [] as Suggestion[];

                if (value) {
                    newOptions = [value];
                }else {
                    const response=await AuthService.suggestionsCopany(inputValue)
                    response.data.suggestions?.map(item=>{
                        newOptions.push(item);
                    })
                }
                setOptions(newOptions);


            }catch (e) {

            }
        }
        if (inputValue === '') {
            setOptions(value ? [value] : []);
            return undefined;
        }

        getCompany();

    },[value,inputValue])


    return (
        <Autocomplete
            getOptionLabel={(option) => (typeof option === 'string' ? option : option.unrestricted_value)}
            filterOptions={(x) => x}
            options={options}
            autoComplete
            includeInputInList
            filterSelectedOptions
            noOptionsText={'Компаний не найдено'}
            value={value}
            onChange={(event: any, newValue: Suggestion | null) => {
                setOptions(newValue ? [newValue, ...options] : options);
                setValue(newValue);
                setInn(newValue)
            }}
            onInputChange={(event, newInputValue) => {
                setInputValue(newInputValue);
            }}
            renderInput={(params) => (
                <TextField {...params} label="Компания" variant="outlined" fullWidth style={{marginBottom:'10px',marginTop:'10px'}}/>
            )}
            renderOption={(option) => {

                return (
                    <Grid container alignItems="center">
                        <Grid item>
                        </Grid>
                        <Grid item xs>
                            <Typography variant="body2">
                                {option.value}
                            </Typography>
                            <Typography variant="body2" color="textSecondary">
                                {`инн ${option.data.inn} ${(option.data.kpp!==undefined)?`кпп ${option.data.kpp}`:''}`}
                            </Typography>
                        </Grid>
                    </Grid>
                );
            }}
        />
    );
};

export default CompanyAutocomplete;